<template>
  <header ref="site-header" class="header">
    <div class="header-inner">
      <div class="nav-top">
        <div class="app-logo">
          <router-link :to="{ name: 'app-root' }" class="nav-link">
            <img src="../../../../assets/images/buckeye-brand.png" alt="Buckeye Transplant">
          </router-link>
          <button type="submit" class="btn btn-toggle shadow-none d-md-none" :class="`${show ? 'active' : ''}`"
            @click="toggleSearch()">
            <font-awesome-icon :icon="['fas', 'bars']" />
            <span class="sr-only">toggle-menu</span>
          </button>
        </div>
      </div>

      <div v-if="currentUser" class="navbar">
        <div class="navbar-wrap">
          <ul class="navbar-list d-md-flex" :class="`${show ? 'd-flex' : 'd-none '}`"
            style="flex-direction: row; align-items:center;">
            <li v-if="currentUser.canRead(PermissionNames.AREA_EXTERNAL)" class="nav-item">
              <router-link class="nav-link" :to="{ name: 'external-dashboards-root'}" title="TxC Home">
                TxC Home
              </router-link>
            </li>
            <li v-if="currentUser.canRead(PermissionNames.AREA_INTERNAL)" class="nav-item">
              <router-link class="nav-link" :to="{ name: 'internal-dashboards-root'}" title="Coordinator Home">
                COORDINATOR HOME
              </router-link>
            </li>
            <li v-if="currentUser.canRead(PermissionNames.AREA_OPERATIONAL_REPORTS)" class="nav-item">
              <router-link class="nav-link" :to="{ name: 'report_root'}" title="Operational Reports">
                Reports
              </router-link>
            </li>
            <li v-if="currentUser.canRead(PermissionNames.AREA_ADMIN)" class="nav-item">
              <router-link class="nav-link" :to="{ name: 'admin_root'}" title="Admin Area">
                Admin
              </router-link>
            </li>
          </ul>
        </div>
        <div class="dropdown user-dropdown">
          <a id="user-drop-down" href="#" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false"
            class="nav-link dropdown-toggle media" style="align-items: center;"
            :title="currentUser.profileInfo.full_name">
            <div class="user-icon">
              <font-awesome-icon :icon="['fas', 'user-circle']" class="headerUserIcon" />
              <span v-if="currentUser.canRead(PermissionNames.INTERNAL_USER_MANAGE_ON_CALL)" class="on-call-indicator"
                :style="{ 'background-color': currentUser.isUserOnCall() ? 'green' : 'red'}" />
            </div>
            <span class="d-none d-md-block userName" style="display: inline-block;">{{ currentUser.profileInfo.full_name }}</span>
          </a>
          <div aria-labelledby="user-drop-down" class="dropdown-menu dropdown-menu-right">
            <router-link v-if="currentUser.canRead(PermissionNames.INTERNAL_USER_MANAGE_ON_CALL)"
              :to="{name: 'user_manage_on_call'}" class="dropdown-item" title="Manage on call">
              <font-awesome-icon :icon="['fas', 'phone']" class="headerMenuIcon pr-2" />
              Manage on-call
            </router-link>
            <router-link v-if="currentUser.canRead(PermissionNames.INTERNAL_USER_MANAGE_PROFILE)"
              :to="{ name: 'user_manage_profile' }" class="dropdown-item" title="Manage my profile">
              <font-awesome-icon :icon="['fas', 'user']" class="headerMenuIcon pr-2" />
              Manage my profile
            </router-link>
            <a href="/users/sign_out" class="dropdown-item" title="Log out">
              <font-awesome-icon :icon="['fas', 'sign-out']" class="headerMenuIcon pr-2" />
              <span class="d-sm-inline">Log out</span>
            </a>
          </div>
        </div>
        <div class="notification-bell" v-if="currentUser.canRead(PermissionNames.INTERNAL_USER_SCHEDULED_NOTIFICATIONS)">
          <a href="#" class="btn btn-fill btn-outline-secondary" title="Scheduled Notifications" @click.prevent="showModalFor('scheduled-notifications-modal')">
            <font-awesome-icon :icon="['fas', 'bell']" aria-hidden="true" size="lg"/><span class="badge">{{ userStore.scheduledNotificationsCount.count }}</span>
          </a>
        </div>
      </div>
    </div>
  </header>
  
    <!-- Render modal component dynamically -->
    <component :is="requestedModal" 
      v-if="requestedModal && currentUser" 
      :ref="requestedModal" 
      @close="modalClosed()" />
</template>

<script lang="js">
import {useAppCoreStore} from "@/src/stores/app-core";
import {PermissionNames} from "@/src/enums";
import ScheduledNotificationsModal from "@/src/components/user/ScheduledNotificationsModal.vue";
import { useUserStore } from '@/src/stores/user';

export default {
  components: {
    ScheduledNotificationsModal
  },
  setup() {
    const appStore = useAppCoreStore();  
    const userStore = useUserStore();
  
    return {
      appStore,
      userStore,
      PermissionNames,
    }
  },
  data() {
    return {
       show:false,
       requestedModal: null
    }
  },
  computed: {
    currentUser() {
      return this.appStore.currentUser;
    }
  },
  async mounted() {
    // If user has permission to access the notifications, then only start loading notifications every 10sec
    if(this.currentUser.canRead(PermissionNames.INTERNAL_USER_SCHEDULED_NOTIFICATIONS)) {
      this.userStore.startLoadingNotifications();
    }
  },
  async beforeUnmount() {
    this.userStore.stopLoadingNotifications();
  },
  methods: {
    toggleSearch() {
      this.show = !this.show;
    },
    showModalFor(modalType) {
      this.requestedModal = modalType;
      this.$nextTick(async () => {
        let modal = this.$refs[modalType];
        if(!modal) {
          alert(`No modal found for ${modalType}`);
          return;
        }
        await this.userStore.loadScheduledNotifications();

        modal.showModal();
      });
    },
    modalClosed(){
    }
  }

}
</script>
<style scoped>
.user-icon {
  position: relative;
  display: inline-block;
}

.on-call-indicator {
  position: absolute;
  bottom: 5px;
  right:5px;
  width:10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid white;
}

.notification-bell {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.badge {
  position: absolute !important;
  top: 2px !important;
  right: 4px;
  background: #f44336;
  color: white;
  border-radius: 50%;
  padding: 2px 6px !important;
  font-size: 10px;
  font-weight: bold;
  line-height: 1;
  min-width: 16px;
  text-align: center;
}
</style>